import { IUser } from "./UsersTypes";

/**
 * @function fullName take a user of IUser interface and return first and last name in the same string
 * @param {IUser} user a user
 * @returns {string} First and Last Name concatenated
 */
function fullName(user: IUser): string {
    if (!user) return '';
    const result = `${user.firstName} ${user.lastName}`;
    return result;
}

export { fullName }; 